import { render } from "./IndexHeader.vue?vue&type=template&id=239a9f83&scoped=true"
import script from "./IndexHeader.vue?vue&type=script&lang=js"
export * from "./IndexHeader.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-239a9f83"

export default script